import React from 'react';
import { cn } from '../lib/utils';
import { theme } from '../config/theme';

const Badge = React.forwardRef(({
  children,
  variant = 'default',
  size = 'md',
  rounded = false,
  className,
  ...props
}, ref) => {
  const baseClasses = 'inline-flex items-center font-medium transition-colors';

  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-0.5 text-sm',
    lg: 'px-3 py-1 text-sm',
  };

  const roundedClasses = rounded ? 'rounded-full' : 'rounded-md';

  const styleByVariant = (() => {
    const soft = theme.mode === 'light' ? 'rgba(0,0,0,.06)' : 'rgba(255,255,255,.06)';
    switch (variant) {
      case 'primary':
        return { background: 'var(--accent-bg)', color: 'var(--accent-text)', border: '1px solid var(--accent-border)' };
      case 'secondary':
        return { background: soft, color: theme.text, border: `1px solid ${theme.border}` };
      case 'accent':
        return { background: 'var(--accent-alt-bg)', color: 'var(--accent-alt-text)', border: '1px solid var(--accent-alt-border)' };
      case 'success':
        return { background: 'rgba(16,185,129,.12)', color: '#065f46', border: '1px solid rgba(16,185,129,.18)' };
      case 'warning':
        return { background: 'rgba(245,158,11,.12)', color: '#92400e', border: '1px solid rgba(245,158,11,.18)' };
      case 'danger':
        return { background: 'rgba(239,68,68,.12)', color: '#991b1b', border: '1px solid rgba(239,68,68,.18)' };
      case 'info':
        return { background: 'rgba(59,130,246,.12)', color: '#1e3a8a', border: '1px solid rgba(59,130,246,.18)' };
      case 'default':
      default:
        return { background: soft, color: theme.text, border: `1px solid ${theme.border}` };
    }
  })();

  const classes = cn(baseClasses, sizes[size], roundedClasses, className);

  return (
    <span ref={ref} className={classes} style={styleByVariant} {...props}>
      {children}
    </span>
  );
});

Badge.displayName = 'Badge';

export default Badge;
